// export const url = 'http://192.168.90.160:8090';
//export const url = 'http://localhost:8090';
export const url = 'https://api.app.finmap.online';


// WEBPACK FOOTER //
// ./src/host/host.js